import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./MultiEntityBanner.css";
import ICONS from "../../../assets/Icons";

const MultiEntityBanner = ({ sessionStatus, showBanner, setShowBanner }) => {
  const navigate = useNavigate();

  if (!sessionStatus || !showBanner) return null;

  const primaryEntityData = JSON.parse(
    sessionStorage.getItem("primaryEntityData"),
  );

  const primaryUser =
    primaryEntityData?.["1_100_"]?.mappings?.[0]?.primary_user;

  const handleLoginClick = () => {
    if (primaryUser) {
      sessionStorage.setItem("prefillUserId", primaryUser);
      Object.keys(sessionStorage).forEach((key) => {
        if (key !== "prefillUserId") {
          sessionStorage.removeItem(key);
        }
      });
    }
    navigate("/login");
  };

  return (
    <div className=" bg-emphasis  w-full p-padding-md rounded-border-radius-md z-z-index-overlay flex justify-between">
      <div className="flex flex-col gap-gap-xs">
        <h1 className="font-sans font-semibold text-font-sm  text-text-primary">
          Multi entity Quick Swap tab is not accessible.
        </h1>

        <p className="font-sans text-font-xs  text-text-primary">
          <span
            onClick={handleLoginClick}
            className="underline font-semibold cursor-pointer "
          >
            Log in with primary ID{" "}
          </span>
          <span>
            - {primaryUser} to access the multi entity Quick Swap tab.
          </span>
        </p>
      </div>
      <button
        onClick={() => {
          const response = JSON.parse(sessionStorage.getItem("response"));

          if (response?.employees) {
            response.employees.can_concierge_login = "N";
            sessionStorage.setItem("response", JSON.stringify(response));
          }
          setShowBanner(false);
        }}
        className="w-icon-sm h-icon-sm flex items-center justify-center text-text-primary  bg-transparent cursor-pointer"
      >
        <img
          alt=""
          src={ICONS?.CLOSE}
          className="flex-shrink-0 w-icon-sm h-icon-sm"
        />
      </button>
    </div>
  );
};

export default MultiEntityBanner;
